/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetDownloadUrlQueryResponse, FilesControllerGetDownloadUrlPathParams, FilesControllerGetDownloadUrlQueryParams, FilesControllerGetDownloadUrl400, FilesControllerGetDownloadUrl401, FilesControllerGetDownloadUrl403, FilesControllerGetDownloadUrl404 } from "../../models/filesController/FilesControllerGetDownloadUrl";

function getFilesControllerGetDownloadUrlUrl(id: FilesControllerGetDownloadUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/files/${id}/download-url` as const }  
  return res
}

/**
 * @description Generates a presigned URL for direct S3 download of the file. By default downloads from kira-processed path (processed PDF). Set useOriginal=true to download from original upload location. Set inline=true to display in browser instead of forcing download. Attachment URLs expire after 5 minutes by default (max 15); inline URLs after 1 hour (max 1 hour).
 * @summary Get presigned download URL for a file
 * {@link /api/v1/files/:id/download-url}
 */
export async function filesControllerGetDownloadUrl(id: FilesControllerGetDownloadUrlPathParams["id"], params?: FilesControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<FilesControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<FilesControllerGetDownloadUrl400 | FilesControllerGetDownloadUrl401 | FilesControllerGetDownloadUrl403 | FilesControllerGetDownloadUrl404>, unknown>({ method : "GET", url : getFilesControllerGetDownloadUrlUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}